import 'jquery-mask-plugin';

import getActionByRoute from './../utils/getActionByRoute';
import tabsFn from '../common/tabs';
import InputMask from './inputMask';
import categoryValidations from './category_validations';
import breakpointChecker from './booksSliders';

const BooksModule = {
  run: (action) => {
    BooksModule[action].call();
  },
  index: () => {
    breakpointChecker();
  },
  show: () => {
    tabsFn();
    breakpointChecker();
    InputMask();
  },
  category: () => {
    breakpointChecker();
    categoryValidations();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  BooksModule.run(getActionByRoute().action);
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/books/books.js